module.exports = __webpack_public_path__ + "static/img/我的专员@4x.0f226a0d.png";